<template>
    <div>
        <div class="menu" :class="{'minimized': sidePanel.minimized || sidePanel.submenu, 'details': sidePanel.details}">
            <h1>
                <span>my</span>247ed.com
            </h1>

            <ul :class="{'hide-details': !sidePanel.details}">
                <router-link :to="{name: 'dashboard'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Dashboard" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-home"></i>
                        </b-tooltip><span class="nav-title">Dashboard</span>
                        <div class="meta"></div>
                    </li>
                </router-link>

                <li class="sub-header">
                    Enrollments & Records
                </li>
                <router-link :to="{name: 'enrollments'}" custom v-slot="{ navigate, isActive }" active-class="active">

                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Course Enrollments" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-chalkboard-teacher"></i>
                        </b-tooltip><span class="nav-title">Course Enrollments</span>
                        <div class="meta">Access, review and log time for your online course enrollments.</div>
                        <div class="meta mt-3" v-if="incompleteCourseApps">
                            <div ><i class="fas fa-exclamation-triangle has-text-warning mr-2 is-size-6"></i>Requires Attention</div>
                        </div>
                    </li>
                </router-link>
                <router-link :to="{name: 'registrations'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Conference Records" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-screen-users"></i>
                        </b-tooltip><span class="nav-title">Conference Records</span>
                        <div class="meta">Manage the in-person or virtual conferences or trainings you've attended.</div>
                        <div class="meta mt-3" v-if="incompleteConfApps">
                            <div ><i class="fas fa-exclamation-triangle has-text-warning mr-2 is-size-6"></i>Requires Attention</div>
                        </div>
                    </li>
                </router-link>
                <router-link :to="{name: 'study-activity'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Study Activity" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-calendar-days"></i>
                        </b-tooltip><span class="nav-title">Study Activity</span>
                        <div class="meta">See all of your logged time across courses and conferences in one calendar.</div>
                        <div class="meta mt-3" v-if="activityState === 'audit_risk'">
                            <div><i class="fas fa-exclamation-triangle has-text-danger activity-flag mr-2 is-size-6"></i>Requires Attention</div>
                        </div>
                        <div class="meta mt-3" v-else-if="activityState === 'elevated'">
                            <div><i class="fas fa-exclamation-triangle has-text-warning activity-flag mr-2 is-size-6"></i>Unusual Activity</div>
                        </div>
                    </li>
                </router-link>
                <router-link :to="{name: 'reports'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Certificates, Forms & Reports" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-file-certificate"></i>
                        </b-tooltip><span class="nav-title">Certificates, Forms & Reports</span>
                        <div class="meta">View and print official completion forms, transcripts, certificates and other reports.</div>
                    </li>
                </router-link>

                <li class="sub-header">
                    Courses & Offerings
                </li>

                <router-link :to="{name: 'course-catalog'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Online Course Catalog" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-browsers"></i>
                        </b-tooltip><span class="nav-title">Online Course Catalog</span>
                        <div class="meta">Browse online courses and offerings.</div>
                    </li>
                </router-link>

                <router-link :to="{name: 'conference-center'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Conference Center" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-presentation"></i>
                        </b-tooltip><span class="nav-title">Conference Center</span>
                        <div class="meta">Register or get credit for a conference or remote content.</div>
                    </li>
                </router-link>

                <li class="sub-header">
                    Account Services
                </li>

                <router-link :to="{name: 'account'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Your Account" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-user-circle"></i>
                        </b-tooltip><span class="nav-title">Your Account</span>
                        <div class="meta">Your preferences and settings.</div>
                    </li>
                </router-link>
                <router-link :to="{name: 'support'}" custom v-slot="{ navigate, isActive }" active-class="active">
                    <li @click="navigate" :class="{'active': isActive}">
                        <b-tooltip label="Support" position="is-right" append-to-body type="is-light" size="is-large">
                            <i class="fad fa-fw fa-life-ring"></i>
                        </b-tooltip><span class="nav-title">Support</span>
                        <div class="meta">View and manage your support tickets.</div>
                    </li>
                </router-link>
            </ul>
        </div>
        <div class="controls ">
            <div class="columns is-gapless">
                <div v-if="!sidePanel.minimized" class="column is-size-7 has-text-grey is-hidden-mobile" style="padding-top: 7px !important;">v{{ version }}</div>
                <div class="column has-text-right">
                    <span @click="toggleDetails()" v-if="!sidePanel.minimized && !sidePanel.submenu"><i class="fad mt-2 mr-3" :class="{'fa-bars': sidePanel.details, 'fa-diagram-cells': !sidePanel.details}"></i></span>
                    <span @click="minimize(false)" v-if="sidePanel.minimized && !sidePanel.submenu"><i class="fad fa-chevrons-right mt-2"></i></span>
                    <span @click="minimize(true)" v-if="!sidePanel.submenu"><i class="fad fa-chevrons-left mt-2"></i></span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import pkg from '../../../package.json';
    import {getActivityStatus} from "../studyActivity/activityStatus";


    export default {
        name: "SidePanelNav",
        data: function() {
            return {
                details: true,
                version: pkg.version,
                activityState: null
            };
        },
        computed: {
            ...mapGetters(['currentUser', 'sidePanel', 'enrollments', 'registrations']),
            incompleteCourseApps: function() {
                if (this.enrollments) {
                    return this.enrollments.some(enrollment => (enrollment.isIncompleteApps && enrollment.completed_at));
                }
                return false;
            },
            incompleteConfApps: function() {
                if (this.registrations) {
                    return this.registrations.some(registration => (registration.isIncompleteApps));
                }
                return false;
            },
        },
        methods: {
            toggleDetails: function() {
                this.$store.commit('setDetails', !this.sidePanel.details);
            },
            minimize: function(state) {
                this.$store.commit('setMinimized', state);
            },
            autoSize: function() {
                let width = window.innerWidth;
                if (width < 1200) {
                    this.$store.commit('setMinimized', true);
                } else {
                    this.$store.commit('setMinimized', false);
                }
            }
        },
        mounted() {
            window.addEventListener('resize', this.autoSize);
            this.autoSize();
            getActivityStatus().then(status => {
                this.activityState = status.state;
            });
        }
    };
</script>

<style lang="scss" scoped>
    .menu {
        position: absolute;
        top: 0;
        bottom: 32px;
        left: 0;
        right: 0;
        overflow-y: auto;

        background-color: #fff;
        background-image: linear-gradient(white, #eeeeee);

        h1 {
            font-weight: 400;
            font-size: 30px;
            margin-top: 1rem;
            display: inline-block;
            cursor: pointer;
            padding: 1rem 1.5rem 0;
            color: #4a4a4a;
            letter-spacing: -1px;

            span {
                font-weight: 900;
                margin-right: 3px;

                color: #336699;

                &.beta {
                    color: #333;
                    border: 1px solid #c2c2c2;
                    border-radius: 3px;
                    padding: 0 4px;
                    font-size: 0.6rem;
                    margin-left: 0.5rem;
                    vertical-align: super;
                    font-weight: normal;
                    letter-spacing: normal;
                }
            }
        }

        ul {
            margin-top: 1.1rem;

            li {
                border-bottom: 1px solid #e0e2e8;
                padding: 1rem 1.4rem;
                font-size: 1rem;
                color: #4a4a4a;
                transition: all 200ms;
                font-weight: bold;
                cursor: pointer;
                background-color: rgba(255, 255, 255, 0.5);

                @media (max-width: 768px) {
                    transition: none;
                }

                &.active {
                    background-color: #336699 !important;

                    color: white;

                    .meta, i {
                        color: white;
                    }

                    // Bulma's has-text-* helpers are !important; the status
                    // color loses to white when the item is the active page
                    .activity-flag {
                        color: white !important;
                    }

                    &:first-child {
                        border-top: 1px solid #336699 !important;
                    }
                }

                &.sub-header {
                    font-weight: bold !important;
                    cursor: default !important;
                    color: #4a4a4a !important;
                    padding: 0.5rem 1.2rem 0.3rem !important;
                    font-size: 0.8rem !important;
                    text-transform: uppercase;
                    background-color: #f3f3f5 !important;
                }

                &:hover {
                    background-color: #567ea7;
                    color: white;

                    .meta, i {
                        color: white;
                    }
                }

                &:first-child {
                    border-top: 1px dashed #e0e2e8;
                }

                i {
                    color: #3c6691;
                    font-size: 1.5rem;
                    vertical-align: middle;
                    margin-right: 1.2rem;
                    transition: all 200ms;

                    @media (max-width: 768px) {
                        transition: none;
                    }
                }

                .meta {
                    transition: color 200ms;

                    font-weight: normal;
                    font-size: 0.8rem;
                    padding-left: 3.15rem;
                    color: #666d7a;
                    line-height: 1rem;

                    @media (max-width: 768px) {
                        transition: none;
                    }
                }
            }

            &.hide-details {
                li {
                    font-size: 0.9rem;
                    font-weight: normal;
                    padding: 0.8rem 1.4rem;

                    .meta {
                        display: none;
                    }

                    i {
                        font-size: 1.2rem;
                        margin-right: 0.8rem;
                    }
                }
            }
        }

        &.minimized {
            overflow: hidden;

            h1 {
                display: none;
            }

            ul {
                padding-top: 4.7rem;

                @media (max-width: 768px) {
                    padding-top: 0;
                }

                li {
                    padding: 1rem 1.1rem;

                    i {
                        font-size: 1.3rem;

                        @media (max-width: 768px) {
                            font-size: 1rem;
                        }
                    }

                    @media (max-width: 768px) {
                        padding: 0.8rem;
                    }

                    .nav-title, .meta {
                        display: none;
                    }

                    &.sub-header {
                        display: none;
                    }
                }
            }
        }
    }

    .controls {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-top: 1px solid #ccc;
        background-color: #ddd;
        padding: 0 1.5rem;
        height: 32px;
        overflow: hidden;
        color: #214367;

        span {
            cursor: pointer;
        }

        @media (max-width: 768px) {

        }
    }
</style>
